import React, { createContext, useContext } from "react";
import { FeedTemplateType, TemplateType } from "../types/template";

type AppRouteContextValue = {
  selectedFeedTemplateType: FeedTemplateType;
  selectedTemplateType: TemplateType | null;
  selectedSdkTemplateType: TemplateType | null;
};

const AppRouteContext = createContext<AppRouteContextValue | undefined>(
  undefined
);

export const AppRouteContextProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: AppRouteContextValue;
}) => (
  <AppRouteContext.Provider value={value}>{children}</AppRouteContext.Provider>
);

export const useAppRouteContext = () => {
  const context = useContext(AppRouteContext);

  if (!context) {
    throw new Error("useAppRouteContext must be used inside AppRouteContextProvider");
  }

  return context;
};
